@if (inputVariant === 'input') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label />
    <input [disabled]="disabled" [ngModel]="rowValue" (ngModelChange)="onRowValueChange($event)" (blur)="onBlur()" matInput type="text" />
  </mat-form-field>
}

@if (inputVariant === 'input[number]') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label />
    <input [disabled]="disabled" [ngModel]="rowValue" (ngModelChange)="onRowValueChange($event)" (blur)="onBlur()" matInput type="number" />
  </mat-form-field>
}

@if (inputVariant === 'select') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label />
    <mat-select [disabled]="disabled" [ngModel]="rowValue" (ngModelChange)="onRowValueChange($event)" (blur)="onBlur()">
      @for (option of options; track option) {
        <mat-option [value]="option.fnValue">{{ option.displayValue }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (inputVariant === 'datepicker') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label />
    <input
      [disabled]="disabled"
      [matDatepicker]="date"
      [ngModel]="rowValue"
      (blur)="onBlur()"
      (ngModelChange)="onRowValueChange($event)"
      matInput
    />
    <mat-datepicker-toggle [for]="date" matSuffix />
    <mat-datepicker #date [calendarHeaderComponent]="DatepickerHeaderComponent" />
  </mat-form-field>
}

@if (inputVariant === 'textarea') {
  <mat-form-field class="textarea-inside-table textarea" appearance="outline">
    <mat-label />
    <textarea
      #autosize="cdkTextareaAutosize"
      [disabled]="disabled"
      [ngModel]="rowValue"
      (ngModelChange)="onRowValueChange($event)"
      (blur)="onBlur()"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows=""
      cdkAutosizeMaxRows="5"
    >
    </textarea>
  </mat-form-field>
}

@if (inputVariant === 'checkbox') {
  <mat-checkbox [disabled]="disabled" [ngModel]="rowValue" (ngModelChange)="onRowValueChange($event)" (blur)="onBlur()" />
}
